// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"8f6ffbf5","471":"8f6ffbf5"}[chunkId] + ".chunk.css";
};